import { Component, Inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { AuthService } from '../../api-authorization/authorize.service';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs'; 

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent {
  passwordForm: FormGroup;
  loading = false;
  error: string | null = null;
  hideOldPassword = signal(true);
  hideNewPassword = signal(true);
  hideConfirmPassword = signal(true);

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private fb: FormBuilder,
    private authService: AuthService
  ) {
    this.passwordForm = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required]
    }, { validator: this.passwordMatchValidator });
  }
  ngOnInit(): void {
    this.passwordForm.valueChanges.subscribe(() => {
      this.error = null;  // Reset error message on any form change
    });
  }

  passwordMatchValidator(group: AbstractControl): ValidationErrors | null {
    const newPassword = group.get('newPassword')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    const confirmControl = group.get('confirmPassword');

    if (confirmControl) {
      const currentErrors = confirmControl.errors || null;
      if (compare(newPassword, confirmPassword)) {
        confirmControl.setErrors({ ...currentErrors, not_matching: true });
      } else {
        confirmControl.setErrors(currentErrors);
      }
    }
    return null;
  }

  toggleVisibility(signalToToggle: any) {
    signalToToggle.set(!signalToToggle());
  }

  changePassword() {
    if (this.passwordForm.invalid) {
      return;
    }

    this.loading = true;
    const { oldPassword, newPassword } = this.passwordForm.value;

    this.error = null;
    this.authService.changePassword(oldPassword, newPassword).subscribe(
      response => {
        this.loading = false;
        this.dialogRef.close(true); // Indicate success
      },
      error => {
        this.loading = false;
        // Konkrete Server-Meldung im Dialog anzeigen (z.B. "Das aktuelle Passwort ist falsch.")
        this.error = this.readError(error);
      }
    );
  }

  /** Liest die konkrete Server-Meldung aus der Fehler-Antwort. */
  private readError(error: any): string {
    const msg = error?.error;
    if (typeof msg === 'string' && msg.trim()) {
      return msg;
    }
    if (msg?.message) {
      return msg.message;
    }
    return 'Passwort konnte nicht geändert werden. Bitte Eingaben prüfen.';
  }
}
function compare(password: string, confirmPassword: string) {
  return password !== confirmPassword && confirmPassword !== '';
}
